import logoImg from "/logo/logo.png";
import office from "/officepic.jpg"
import image4 from "/image-4.webp"
import image5 from "/image-5.webp"
import image2 from "/image-2.webp"
import marathon from "/marathon4.jpg"
import marathon2 from "/marathon2.webp"
import amore1 from "/amore1.webp"
import image from "/image.webp"
import andheri3 from "/andheri3.webp"
import img from "/img.webp"
import diamond3 from "/diamond3.webp"
import amore3 from "/amore3.webp"
import matulya4 from "/matulya4.webp"

export const logo = logoImg;
export const office_main = ""
export const office_pic = office

//export const background = "https://cdn-bnokp.nitrocdn.com/QNoeDwCprhACHQcnEmHgXDhDpbEOlRHH/assets/images/optimized/rev-33819c0/www.decorilla.com/online-decorating/wp-content/uploads/2022/03/Modern-Office-Interior-with-Open-Floor-Plan-1536x1024.jpeg"
export const photo1 = image4
export const photo2 = image5
export const photo3 = image2

export const gallery1 = marathon
export const gallery2 = marathon2
export const gallery3 = amore1
export const gallery4 = image
export const gallery5 = andheri3
export const gallery6 = img
export const gallery7 = diamond3
export const gallery8 = amore3
export const gallery9 = matulya4

export const background2 = "https://www.603thecoworkingspace.com/#lg=1&slide=0"
export const vid = "https://videos.files.wordpress.com/he8mF3Bd/about.mp4"